export default __webpack_public_path__ + "static/media/message-like.5c6303b0.mp3";